import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { IconButton } from '@picsio/ui';
import { Close } from '@picsio/icons';
import localization from '../shared/strings';
import Tooltip from '../components/Tooltip';

import colorsHelper from '../helpers/colorsHelper';

const COLORS = colorsHelper.colors.list;

const Colors = ({
  value = [],
  onChange = () => null,
  className = '',
  highlight = false,
  error = false,
  disabled = false,
  deselectColors = null,
  highlightAnimationReset = () => null,
}) => {
  const customLabels = useSelector((state) => state.user?.team?.settings?.colorLabels || {});

  const handleAnimationEnd = useCallback(
    () => highlightAnimationReset('color'),
    [highlightAnimationReset],
  );

  const handleChange = useCallback(
    (event) => {
      const colorValue = event.currentTarget.dataset.color || 'nocolor';
      if (!disabled) onChange(colorValue);
    },
    [disabled, onChange],
  );

  return (
    <div
      className={cn('defaultColorList', className, { isError: error, disabled })}
      onAnimationEnd={handleAnimationEnd}
    >
      <ul
        className={cn({
          highlightBlink: highlight,
        })}
      >
        {COLORS.map((color) => (
          <Tooltip key={color.value} content={customLabels[color.value] || color.title} placement="top">
            <li
              onClick={handleChange}
              data-color={color.value}
              className={value.includes(color.value) ? 'act' : ''}
            >
              <span
                className={`filterLabelColor ${!color.background ? 'filterUnlabeledColor' : ''}`}
                style={{ background: color.background || '' }}
              />
            </li>
          </Tooltip>
        ))}
        <If condition={deselectColors}>
          <Tooltip content={localization.DETAILS.textDeselectColors} placement="top">
            <li
              className="deselectColors"
            >
              <IconButton size="lg" onClick={deselectColors}>
                <Close />
              </IconButton>
            </li>
          </Tooltip>
        </If>
      </ul>
    </div>
  );
};

Colors.propTypes = {
  className: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  onChange: PropTypes.func,
  highlight: PropTypes.bool,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  highlightAnimationReset: PropTypes.func,
  deselectColors: PropTypes.func,
};

export default Colors;
